import { KeyType, KeyTypes } from './types'

const CAMP_PREFIX = 'camp'
const CATEGORY_PREFIX = 'cat'
const COURSE_PREFIX = 'course'
const CHAPTER_PREFIX = 'lesson'
const SUBCAT_PREFIX = 'subcat'
const OUTCOME_PREFIX = 'outcome'

const getParsedId = ({
  prefix,
  id,
}: {
  prefix: string
  id: string | number
}) => (prefix !== '' ? `${prefix}-${id}` : `${id}`)

export const getTrackedId = ({
  key,
  id,
}: {
  key: KeyType
  id: string | number
}) => {
  const prefix = getIdParsingPrefix(key)

  return getParsedId({ prefix, id })
}

export const getTrackedIds = ({
  ids,
  key,
}: {
  ids: string[] | number[]
  key: KeyType
}) => ids?.map((id) => getTrackedId({ key, id })).join(',')

const getIdParsingPrefix = (key: KeyType) => {
  switch (key) {
    case KeyTypes.CAMP: {
      return CAMP_PREFIX
    }
    case KeyTypes.CATEGORY: {
      return CATEGORY_PREFIX
    }
    case KeyTypes.SUBCATEGORY: {
      return SUBCAT_PREFIX
    }
    case KeyTypes.CLASS: {
      return COURSE_PREFIX
    }
    case KeyTypes.LESSON: {
      return CHAPTER_PREFIX
    }
    case KeyTypes.OUTCOME: {
      return OUTCOME_PREFIX
    }
    default:
      return ''
  }
}
